import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ClientBrief() {
  return (
    <section className="client__brief p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} className="m-auto text-center">
            <h2 style={{ color: "#000" }}>
              Client <span style={{ color: "#2B8FE8" }}>Brief</span>
            </h2>
            <p>
              A strong desire to bring comfort and convenience to customers in
              leasing cars is what motivated Michael Oz to create Oz Leasing in
              2013. Today, the company is one of the leading auto establishments
              in America that operates completely online.
            </p>
            <h2 style={{ color: "#717783" }}>Mission</h2>
            <div className="mission_boxes">
              <div className="mission_box">
                YEAR - <span style={{ color: "#2B8FE8" }}> 2018</span>
              </div>
              <div className="mission_box">
                ROLE - <span style={{ color: "#2B8FE8" }}> UI/UX DESIGN</span>
              </div>
              <div className="mission_box">
                TYPE -<span style={{ color: "#2B8FE8" }}> WEB DEVELOPMENT</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientBrief;
